// @flow
import * as React from 'react';

import { Field } from 'redux-form';
import type { TRound } from '../../../../modules/types';
import { FormField, FormSelect, FormRadio } from '../../../../components/index';

import { LEAGUE_SIZE } from '../../../../helpers/index';
import { FormDateField } from "../../../../components";
import { league_tooltips } from "../../../../helpers";

type Props = {
	is_draft_commissioner: boolean,
	rounds: Array<TRound>,
	maxDate: string,
	changeFieldValue: Function
}

export const LeagueSettings = (
	{ rounds, maxDate, is_draft_commissioner, changeFieldValue }: Props
) => {

	const handleSelectChange = (event,name) => {
		const roundNo = Number(event.target.value);
		if(name === "start_round" && roundNo >= 22) {
			changeFieldValue('finals', 0);
		}
		changeFieldValue('start_round', roundNo);
	};
	return(
		<div>
			<Field
				label='Give your Draft League a name*'
				type='text'
				name='name'
				placeholder='League name'
				component={FormField}
				tooltip={league_tooltips.name}
			/>

			<Field
				label='League Size*'
				name='size'
				options={LEAGUE_SIZE}
				component={FormSelect}
				tooltip={league_tooltips.size}
			/>

			<Field
				label='League Start Round*'
				name='start_round'
				options={rounds}
				component={FormSelect}
				tooltip={league_tooltips.start_round}
				onSelectChange={handleSelectChange}
			/>

			<FormRadio
				label='Privacy Settings*'
				name='privacy'
				elements={[
					{
						value: 0,
						text: 'Private',
					},
					{
						value: 1,
						text: 'Public',
					}
				]}
				tooltip={league_tooltips.privacy}
				is_disabled={false}
			/>
			<Field
				label='Draft Date & Time'
				type='text'
				name='draft_start'
				placeholder='Draft Date & Time'
				component={FormDateField}
				maxDate={maxDate}
				tooltip={league_tooltips.draft_start}
				is_disabled={is_draft_commissioner}
			/>
		</div>
	);
};

export default LeagueSettings;


// WEBPACK FOOTER //
// ./src/pages/leagues/leaguesCreate/forms/LeagueSettings.js